import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-question-paper-code',
  templateUrl: './question-paper-code.component.html',
  styleUrls: ['./question-paper-code.component.scss']
})
export class QuestionPaperCodeComponent implements OnInit {
  QuestionPaperCodeForm: FormGroup;
  examListForOP: any;
  filteredexamListForOP: any;
  mymodel: any;
  examListForOP1: { branch: string; subcode: string; subName: string; }[];
  examListForOPGrid: any;
  showLine=false;
  arr=[];
  filteredexamListForOPGrid: any;
  NewQPArray: FormArray;
  dialogRef: MatDialogRef<any>;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public router: Router,
    public fb: FormBuilder) { }
  QPlist;
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fectExam(this.SessionNo);
    }
    window.scroll(0, 0);
    this.QuestionPaperCodeForm = this.fb.group({
      ShId: new FormControl(),
      CSExBr: new FormControl(),
      Code: new FormControl(),
      NewQPArray: new FormArray([]),
    });
    this.fetchSecretData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      this.fectExam(this.SessionNo);
      }
    );
  }



  fectExam(SnNo) {
    const payload = {};
    payload['ShSnNo'] = SnNo;
    payload['LoginId'] = sessionStorage.getItem('userId');

    this.umsService.fetchExamForQP(payload).subscribe((res) => {
      if (res.status) {
        this.examListForOP = res.data;
        this.filteredexamListForOP = this.examListForOP.slice();
      }
      else {
      }
    });
  }

  valuechange(e) {
    this.updateQP(e.value);
  }

  fetchQPForTable(e) {
    let payload = {};
    const arr = <FormArray>this.QuestionPaperCodeForm.controls.NewQPArray; 
    arr.controls = [];
    sessionStorage.setItem('ShId', e);
    // this.NewQPArray.clear();
    payload['ShId'] = e;
    payload['StrId'] = '';
    this.umsService.fetchQPDataForGrid(payload).subscribe((res) => {
      if (res.status) {
        if(res.data.length == 0){
          this.showLine = false;
        }
        else{
          this.showLine = true;
        }
        res.data.forEach(element => {
          this.addNewRow(element);
       });
      
      }
      else {

        this.openConformationModalBox();
      }

    });
  }


  add() {
    // alert(this.umsService.secretdata['Qp'])
    let abc = sessionStorage.getItem('ShId');
    let payload = {};
    payload["ShId"] = abc;
    payload["Code"] = '';
    payload["EsId"] = 0;
    payload["AMD"] = this.umsService.secretdata['Qp'];
    payload["Inst"] = 9;
    this.umsService.addQPCode(payload).subscribe(res => {
      if (res.status) {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })

  }




  updateQP(e) {
    this.spinner.show()
    let shId = sessionStorage.getItem('ShId');
    let updatepayload = this.examListForOPGrid;
    let payload = {};
    payload["ShId"] = shId;
    payload["Code"] = e.Code;
    payload["EsId"] = e.EsId;//pass esid get from payload
    payload["AMD"] = '';
    payload["Inst"] = 9;
    this.umsService.updateQPCode(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        this.spinner.hide();
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let  data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }


  prepopulateNew(e) {

    const creds = this.QuestionPaperCodeForm.controls.NewQPArray as FormArray;
    creds.push(
      this.fb.group({
        ShId: new FormControl(),
        CSExBr: new FormControl(),
        Code: new FormControl(),
      })
    );
  }
  getNewCdArrayControls() {
    return (this.QuestionPaperCodeForm.get('NewQPArray') as FormArray).controls;
  }

  addNewRow(e) {
    const creds = this.QuestionPaperCodeForm.controls.NewQPArray as FormArray;
    
    creds.push(
      this.fb.group({
        Code: new FormControl(e.QpCode),
        subCode: new FormControl(e.SubCode),
        subName: new FormControl(e.SubName),
        branchName: new FormControl(e.StrCode),
        EsId: new FormControl(e.EsId)
      })
    );
  }




  openConformationModalBox(){
    let  data = {}
    data['message'] = 'List Empty, Do You Want To Generate One?'
    data['title'] = 'Information'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if(result == 'yes'){
         this.add();
      }else{
        // this.ngOnInit();
      } 
    });
   }

   print(){
    let submitpayload = this.QuestionPaperCodeForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'Question-Paper-Code';
    payload1['ShId'] = submitpayload.ShId
    payload1['StrId'] = submitpayload.CSExBr
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 122,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }
}
